import LogoutIcon from "@mui/icons-material/Logout";
import { AppBar, Box, Button, Grid, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ChooseLanguage from "../../components/base/ChooseLanguage";
import { useAuth } from "../../context/auth";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import { LandingPageTile } from "../LandingPage/LandingPageTile";
import ReceiptIcon from '@mui/icons-material/Receipt';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PaymentsIcon from '@mui/icons-material/Payments';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import { BackGroundImage } from "../../media/background";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export const FinancialPanelLandingPage = () => {
    const { navigateToLogoutRoute, navigateToRedirectBackToMyHomeRoute } = useAuth();
    const { t } = useTranslation();

    const { hasAccess } = useAccessControl([USER_ROLES.ADMIN, USER_ROLES.INVESTMENT_DPI, USER_ROLES.ACCOUNT]);

    if (!hasAccess) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                marginTop: -1,
                backgroundImage: `url(${BackGroundImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "right",
                marginBottom: "-40px"
            }}
        >
            {/* AppBar with Logout Button and Language Selector */}
            <AppBar position="static" color="primary">
                <Toolbar sx={{ justifyContent: "flex-end" }}>
                    {/* <ChooseLanguage /> */}
                    <Button
                        color="inherit"
                        sx={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "rgba(255,255,255,0.15)",
                            "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.39)",
                            },
                            borderRadius: 2,
                            px: 3,
                        }}
                        onClick={navigateToRedirectBackToMyHomeRoute}
                    >
                        {t("page.financial_panel.return")}
                    </Button>
                    <Button color="inherit" onClick={navigateToLogoutRoute} startIcon={<LogoutIcon />}>
                        {t("log_out")}
                    </Button>
                </Toolbar>
            </AppBar>
            {/* Main Content */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    flexGrow: 1,
                    padding: 3,
                }}
            >
                <Typography
                    variant="h2"
                    component="h2"
                    align="center"
                    style={{  fontSize:"50px", marginTop: 10 }}
                >
                    {t("page.financial_panel.financial_panel")}
                </Typography>

                <Grid
                    container
                    justifyContent="center"
                    spacing={1}
                    sx={{
                        margin: "0 auto",
                        marginLeft: 0,
                        paddingLeft:0,
                        marginTop:"-75px",
                        marginBottom: 0
                    }}
                >
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.financial_panel.bankings")}
                            pageUrl={"/financial-panel/banking/"}
                            icon={<ReceiptIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.financial_panel.agreements")}
                            pageUrl={"/financial-panel/agreements/"}
                            icon={<HandshakeIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.financial_panel.payments")}
                            pageUrl={"/financial-panel/transfer/investment_bills/"}
                            icon={<PaymentsIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.financial_panel.debt_collection")}
                            pageUrl={"#"}
                            icon={<AssuredWorkloadIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.financial_panel.invoicing")}
                            pageUrl={"/financial-panel/invoicing/investment_bills/"}
                            icon={<ReceiptLongIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};
